import { g as gsapWithCSS } from "@theme/index";
class MixBox extends HTMLElement {
  connectedCallback() {
    this.init();
  }
  init() {
    Promise.all([this.waitForSwiper(), this.waitForGsap()]).then(() => {
      this.setupSwiper();
    });
  }
  waitForSwiper() {
    return new Promise((resolve) => {
      if (customElements.get("swiper-container")) {
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          if (customElements.get("swiper-container")) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
      }
    });
  }
  waitForGsap() {
    return new Promise((resolve) => {
      if (typeof gsapWithCSS !== "undefined") {
        resolve();
      } else {
        const checkInterval = setInterval(() => {
          if (typeof gsapWithCSS !== "undefined") {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
      }
    });
  }
  setupSwiper() {
    const swiperEl = this.querySelector(".looks-swiper");
    if (!swiperEl) return;
    this.featuredImages = this.querySelectorAll(".featured-image");
    const initSwiper = () => {
      if (swiperEl.swiper) {
        swiperEl.swiper.on("slideChange", () => {
          this.handleSlideChange(swiperEl.swiper);
        });
      } else {
        setTimeout(initSwiper, 100);
      }
    };
    initSwiper();
  }
  handleSlideChange(swiper) {
    const activeIndex = swiper.activeIndex;
    const activeImage = this.querySelector(
      `.featured-image[data-look-index="${activeIndex}"]`
    );
    if (!activeImage) return;
    const inactiveImages = Array.from(this.featuredImages).filter(
      (img) => img !== activeImage
    );
    inactiveImages.forEach((img) => {
      gsapWithCSS.killTweensOf(img);
      img.style.display = "none";
      gsapWithCSS.set(img, { clearProps: "opacity" });
    });
    gsapWithCSS.killTweensOf(activeImage);
    activeImage.style.display = "flex";
    gsapWithCSS.fromTo(
      activeImage,
      { opacity: 0 },
      { opacity: 1, duration: 0.4, ease: "power2.out" }
    );
  }
}
customElements.define("mix-box", MixBox);
